// :cow: Cosmose CONFIDENTIAL :iso:
import { CanActivate, Router } from '@angular/router';
import { Injectable } from '@angular/core';
import { Store } from '@ngrx/store';
import { State } from '../../store';
import { AuthService } from '../shared/auth.service';

@Injectable()
export class LoginGuard implements CanActivate {
  constructor(
    private store: Store<State>,
    private authService: AuthService,
    private router: Router,
  ) {
  }

  canActivate() {
    const isLoggedIn = this.authService.isLoggedIn();

    if (isLoggedIn) {
      this.router.navigateByUrl('/');
      return false;
    }

    this.authService.clearTokens();
    return true;
  }
}
